<div class="modal modal-cookies" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body pt-2">
        <div class="modal-title mb-2 text-right">
          <img class="cursor" src="assets/img/close.svg" (click)="acceptCookies()" width="10" data-dismiss="modal">
        </div>
        <div class="modal-text font-12">
          {{"COOKIES_TEXT"|translate}}       
        </div>
      </div>
      <div class="modal-footer">
        <div class="button btn-grey text-uppercase" data-dismiss="modal" (click)="acceptCookiesAndGoToDetails()">Leggi l'informativa</div>
        <div class="button btn-green text-uppercase" (click)="acceptCookies()" data-dismiss="modal">{{"ACCEPT"|translate}}</div>
      </div>
    </div>
  </div>
</div>